/** The event frame's chrome. */
export default {
  noUpcomingEvent: "No upcoming event",
  tomorrow: "Tomorrow",
} as const;
